import { SxProps, Typography } from '@mui/material';

export const FormSectionTitle = ({ title, sx }: { title: string; sx?: SxProps }) => (
  <Typography variant="body1" sx={sx}>
    {title}
  </Typography>
);
